import { Button } from 'components';
import styled from 'styled-components';

export const Wrapper = styled.div.attrs({
  className: 'self-start mt-5 w-full max-w-6xl mx-auto px-4 pb-[150px]',
})``;
export const ErrorStack = styled.div.attrs({ className: 'flex flex-col text-center space-y-4' })``;
export const ImmunizationSlot = styled.div.attrs({ className: 'mt-4' })``;

export const DismissButton = styled(Button).attrs({ className: 'self-end mr-4' })``;

export const LanguageStatusText = styled.span.attrs({
  className: 'text-sm text-muted-foreground',
})``;
